"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceMessage = void 0;
const ModelCommon_1 = require("../ModelCommon");
const typeName = 'DeviceMessage';
class DeviceMessage extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, ob);
    }
}
exports.DeviceMessage = DeviceMessage;
